export default __webpack_public_path__ + "static/media/NAPTUNE.d8032642.png";